const state = {
    itens: [],
    item: {
        name: '',
        value: '',
        is_active: false
    }
};

export default state;
